import React from "react";
import { useLocation } from "react-router-dom";
import Styled from "styled-components";
import Slider from "react-slick";
import { useQuery } from "@tanstack/react-query";
import { BASE_URL } from "./Config/Config";

function Testimonialarea() {
  const location = useLocation();
  const API = `${BASE_URL}/testimonial/`;

  // ✅ React Query fetch function
  const fetchTestimonials = async () => {
    const response = await fetch(API, {
      method: "GET",
      headers: {
        "content-type": "application/json",
      },
      credentials: "include",
    });
    const result = await response.json();
    return result.data;
  };

  // ✅ UseQuery hook
  const { data: testimonialsdata = [], isLoading } = useQuery({
    queryKey: ["testimonials"],
    queryFn: fetchTestimonials,
  });

  // Existing DOM setup (unchanged)
  React.useEffect(() => {
    const bgSrcElements = document.querySelectorAll("[data-bg-src]");
    bgSrcElements.forEach((element) => {
      const src = element.getAttribute("data-bg-src");
      if (src) {
        element.style.backgroundImage = `url(${src})`;
        element.classList.add("background-image");
        element.removeAttribute("data-bg-src");
      }
    });

    const bgColorElements = document.querySelectorAll("[data-bg-color]");
    bgColorElements.forEach((element) => {
      const color = element.getAttribute("data-bg-color");
      if (color) {
        element.style.backgroundColor = color;
        element.removeAttribute("data-bg-color");
      }
    });

    const maskSrcElements = document.querySelectorAll("[data-mask-src]");
    maskSrcElements.forEach((element) => {
      const mask = element.getAttribute("data-mask-src");
      if (mask) {
        element.style.maskImage = `url(${mask})`;
        element.style.WebkitMaskImage = `url(${mask})`;
        element.classList.add("bg-mask");
        element.removeAttribute("data-mask-src");
      }
    });
  }, [location.pathname]);

  const sliderSettings = {
    dots: true,
    customPaging: (i) => (
      <button
        style={{
          width: "12px",
          height: "12px",
          backgroundColor: "gray",
          borderRadius: "50%",
          border: "none",
        }}
      ></button>
    ),
    infinite: true,
    speed: 1000,
    slidesToShow: 4,
    autoplay: true,
    autoplaySpeed: 1000,
    responsive: [
      { breakpoint: 1200, settings: { slidesToShow: 3 } },
      { breakpoint: 992, settings: { slidesToShow: 2 } },
      { breakpoint: 768, settings: { slidesToShow: 1 } },
    ],
  };

  return (
    <>
      <Wrapper>
        <section
          className="testi-area-4 overflow-hidden space"
          data-bg-src="/assets/img/bg/testi_bg_3.png"
        >
          <div className="shape-mockup testi2-bg-shape2 spin d-xl-block d-none">
            <img
              src="/assets/img/testimonial/testi-bg-shape_3_1.png"
              alt="img"
            />
          </div>

          <div className="container">
            <div className="title-area text-center">
              <span className="sub-title">
                <i className="fal fa-book me-2" /> Our Students Testimonials
              </span>
              <h2 className="sec-title text-white">Students Say’s About Us!</h2>
            </div>
          </div>

          <div className="container-fluid">
            {isLoading ? (
              <p className="text-center text-white">Loading testimonials...</p>
            ) : (
              <Slider {...sliderSettings}>
                {testimonialsdata.map((curdata, index) => (
                  <div key={curdata.id || index} className="testi-card-wrapper equal-height">
                    <div className="testi-box style3 ">
                      <div className="course-rating">
                        <div
                          className="star-rating"
                          role="img"
                          aria-label={`Rated ${curdata.rating} out of 5`}
                        >
                          <span
                            style={{
                              width: `${(curdata.rating / 5) * 100}%`,
                            }}
                          >
                            Rated{" "}
                            <strong className="rating">{curdata.rating}</strong>{" "}
                               out of 5
                          </span>
                        </div>
                        ({curdata.rating})
                      </div>

                      <p className="testi-box_text">
                        {curdata.text.length > 120
                          ? curdata.text.slice(0, 120) + "..."
                          : curdata.text}
                      </p>


                      <div className="testi-box_bottom">
                        <div className="testi-box_img">
                          <img
                            src={
                              curdata.avatar
                                ? `${BASE_URL}${curdata.avatar}`
                                : "/assets/img/testingimg.jpg_img.webp"
                            }
                            alt="testimonial user"
                            style={{
                              height: "120px",
                              width: "121px",
                              objectFit: "cover",
                            }}
                          />
                        </div>

                        <div className="testi-box-author-details">
                          <h3 className="testi-box_name">{curdata.name}</h3>
                          <span className="testi-box_desig">
                            {curdata.designation}
                          </span>
                        </div>

                        <div className="testi-box_quote">
                          <img
                            src="/assets/img/icon/testi-quote2.svg"
                            alt="quote"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </Slider>
            )}
          </div>
        </section>
      </Wrapper>
    </>
  );
}

const Wrapper = Styled.section`
.testi-card-wrapper { padding: 10px; }
`;

export default Testimonialarea;
